import {Component, ElementRef, Inject, OnInit, Renderer2} from '@angular/core';

import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ConteudoCabecalhoTabelaRim} from "../../../../core/conteudo-cabecalho-tabela-rim";
import {ConteudoColunaRim} from "../../../../core/conteudo-coluna-rim";

@Component({
    selector: 'largura-tabel-dialog',
    templateUrl: './editar-cabecalho-tabela-dialog.component.html',
    styleUrls: ['./editar-cabecalho-tabela-dialog.component.css']
})
export class EditarCabecalhoTabelaDialogComponent implements OnInit {

    pinRandom = Math.random();

    cabecalho: ConteudoCabecalhoTabelaRim;
    colunas: ConteudoColunaRim[] = [];

    constructor(private dialogRef: MatDialogRef<EditarCabecalhoTabelaDialogComponent>,
                private el: ElementRef,
                private renderer: Renderer2,
                @Inject(MAT_DIALOG_DATA) data: any) {
        if (data) {
            this.cabecalho = data.cabecalhoSelecionado;
            this.colunas = data.colunas;

            dialogRef.disableClose = data.disableClose;
        }

    }

    ngOnInit() {
    }

    voltar() {
        this.dialogRef.close();
    }

    onChangeAlinhamento() {
        this.colunas.forEach(conteudo => {
            conteudo.alinhamento = this.cabecalho.alinhamento;
        })
    }

}